const MODULE_NAME = 'APP_PASSWORD_EDIT';
const APP_PASSWORD_EDIT_SUBMIT = MODULE_NAME + 'SUBMIT';
const APP_PASSWORD_EDIT_COMPLETED = MODULE_NAME + 'COMPLETED';
const APP_PASSWORD_EDIT_FAILED = MODULE_NAME + 'FAILED';

export {
  APP_PASSWORD_EDIT_SUBMIT,
  APP_PASSWORD_EDIT_COMPLETED,
  APP_PASSWORD_EDIT_FAILED
};
